module.exports = __webpack_public_path__ + "static/logo-82fb2d14dd46a019c861913198f958ef.png";